import React, { useMemo } from "react";
import { MapPin } from "lucide-react";

/** Calm, text-first list of future service locations from the existing content API. */
export default function UpcomingCities({ data }) {
  const cities = useMemo(() => (Array.isArray(data?.cities) ? data.cities : [])
    .filter((city) => city && city.enabled !== false && String(city.name || "").trim())
    .map((city, index) => ({ ...city, key: city.id || `city-${index}` })), [data]);

  if (data?.enabled === false || cities.length === 0) return null;

  return (
    <section id="upcoming-cities" data-testid="upcoming-cities-section" aria-labelledby="upcoming-cities-title" className="navi-exp-section navi-city-list-section px-6 py-12 sm:py-16">
      <div className="navi-wrap">
        <div className="max-w-[42rem]">
          <div className="text-xs uppercase tracking-[.16em] font-semibold navi-city-list-eyebrow">NAVI CARE · SERVICE AREAS</div>
          <h2 id="upcoming-cities-title" className="mt-3 text-3xl sm:text-[2.5rem] font-semibold tracking-tight leading-tight">{data?.title || "Coming to more cities"}</h2>
          <p className="mt-3 text-muted-foreground leading-relaxed">{data?.subtitle || "We are preparing to bring convenient doorstep care to more communities."}</p>
        </div>
        <ul className="navi-city-list mt-7" aria-label="Upcoming service locations">
          {cities.map((city) => (
            <li key={city.key} className="navi-city-list-card">
              <div className="min-w-0">
                <span className="navi-city-list-status">{city.status || "Coming soon"}</span>
                <h3>{city.name}</h3>
                {(city.state || city.location_name || city.description) && (
                  <p>{city.description || [city.location_name, city.state].filter(Boolean).join(" · ")}</p>
                )}
              </div>
              <MapPin aria-hidden="true" className="navi-city-list-pin" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

